import { render } from "./menus.vue?vue&type=template&id=27168e23&ts=true"
import script from "./menus.vue?vue&type=script&lang=ts"
export * from "./menus.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/workshop/teambition-frontend/node_modules/.pnpm/vue-loader@16.8.3_6zog4g7lmcedlfqueoidvwcx7q/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__